export default class CustomerType {
    constructor(obj = {}) {
        Object.assign(this, obj);
    }

    public id: number;
    public name: string;
}
